import React, { Component } from "react";
import Headers from "../Layouts/Headers";
import TheatreSidebar from "../Layouts/TheatreSidebar";

import axios from "axios";
import $ from "jquery";

export class PostOpPreliminary extends Component {
  constructor(props) {
    super(props);

   

    const url = "";

    this.state = {
      Doctors:"",
      Diagnosis:"",
      Preoperativediagnosis:"",
      IntraoperativeDiagnosis:"",
      Anesthesiagiven:"",
      OperationPerformed:"",
      Immediaterecoverycare:"",
      Handovergiven:"",
      Datetime:"",
      loading:false

      // 				visitid = request.headers["visitid"],
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.PrintWindow = this.PrintWindow.bind(this);
  }

  PrintWindow(event) {
    document.title =
      localStorage.getItem("currentVisitName") + "`s " + this.constructor.name;
    $(".modal").hide();
    window.print();
  }
  componentDidMount() {
    $(".deadonehouryes").click(function () {
      $(".deadonereason").show();
    });
    $(".deadonehourno").click(function () {
      $(".deadonereason").hide();
    });

    $(".stillbirthyes").click(function () {
      $(".stillbirthtype").show();
    });
    $(".stillbirthno").click(function () {
      $(".stillbirthtype").hide();
    });
  }

  handleChange(event) {
    this.setState({ [event.target.name]: event.target.value });
  }

  handleSubmit = (event) => {
    const headers = {
      "Content-Type": "application/json",
      token: localStorage.getItem("accessToken"),
      visitid: localStorage.getItem("currentVisitId"),
      surgeryid: localStorage.getItem("surgeryid"),
    };
    event.preventDefault();
    console.log(this.state);
    this.setState({
      loading: true
    })
    const _ = require("lodash");  

const newState = _.omit(this.state, ['loading'])
console.log(localStorage.getItem("surgeryid"))
console.log(newState)
    axios
      .post(
        this.api_url+"optheatre/operativeorders/post/labour/preliminary",
        newState,
        { headers: headers }
      )
      .then((response) => {
        console.log(response);
        this.setState({
          loading: false
        })
        if (response.data["status"]) {
          $(".alert-success").show();
        }

        setTimeout(function () {
          window.location.href = "/theatre/post/op/observations/care1";
        }, 500);

        //
      })
      .catch((error) => {
        console.log(error);
        this.setState({
          loading: false
        })
        $('#SubmitError').show();
        $(".alert-success").hide();
      });
  };
  render() {
    const font16 = { fontSize: "16px" };
    const fontFamilyNunito = { fontFamily: "Nunito, sans-serif" };
    const floatRight = { float: "right;" };
    const floatLeft = { float: "left;" };
    const displayHidden = { display: "none" };
    const {
      Doctors,
      Diagnosis,
      Preoperativediagnosis,
      IntraoperativeDiagnosis,
      Anesthesiagiven,
      OperationPerformed,
      Immediaterecoverycare,
      Handovergiven,
      Datetime,
      loading
    } = this.state;
    return (
      <div>
        <Headers />
        <TheatreSidebar />

        <main>
          <div className="container p-2">
            <form onSubmit={this.handleSubmit}>
              <div className="form-row pt-4">
                <div className="col-md-4 p-2"></div>
              </div>
              <div className="form-row pt-4">
                <div className="col-md-4 text-lg-center font-weight-bold p-1">
                  <p className="text-capitalize" style={font16}>
                    Post Operative Preliminary
                  </p>
                </div>

                <div className="col-md-4 p-2">
                  <div className="py-1">
                    <h6 className="text-capitalize" style={fontFamilyNunito}>
                      Doctors
                    </h6>
                    <input
                      type="text"
                      className="form-control"
                      onChange={this.handleChange}
                      value={Doctors}
                      name="Doctors"
                      required
                    />
                  </div>

                  <div className="py-1">
                    <h6 className="text-capitalize" style={fontFamilyNunito}>
                      Diagnosis
                    </h6>
                    <input
                      className="form-control"
                      onChange={this.handleChange}
                      value={Diagnosis}
                      name="Diagnosis"
                      type="text"
                      required
                    />
                  </div>
                </div>
                <div className="col-md-4 p-2">
                  <div className="py-1">
                    <h6 className="text-capitalize" style={fontFamilyNunito}>
                      Preoperative diagnosis
                    </h6>
                    <input
                      className="form-control"
                      onChange={this.handleChange}
                      value={Preoperativediagnosis}
                      name="Preoperativediagnosis"
                      type="text"
                      required
                    />
                  </div>
                  {/* <div className="py-1">
                         <h6 className="text-capitalize" style={ fontFamilyNunito }>Gestational Age</h6><input onChange={this.handleChange} value={alive} name="GestationalAge" className="form-control" type="text" required/>
                     </div> */}
                </div>
              </div>

              <div className="form-row pt-4">
                <div className="col-md-4 text-lg-center font-weight-bold p-1">
                  <p className="text-capitalize" style={font16}></p>
                </div>

                <div className="col-md-4 p-2">
                  <div className="py-1">
                    <h6 className="text-capitalize" style={fontFamilyNunito}>
                      Intraoperative Diagnosis
                    </h6>
                    <input
                      className="form-control"
                      onChange={this.handleChange}
                      value={IntraoperativeDiagnosis}
                      name="IntraoperativeDiagnosis"
                      type="text"
                      required
                    />
                  </div>
                  <div className="py-1">
                    <h6 className="text-capitalize" style={fontFamilyNunito}>
                      Anesthesia given
                    </h6>
                    <input
                      className="form-control"
                      onChange={this.handleChange}
                      value={Anesthesiagiven}
                      name="Anesthesiagiven"
                      type="text"
                      required
                    />
                  </div>
                </div>
                <div className="col-md-4 p-2">
                  <div className="py-1">
                    <h6 className="text-capitalize" style={fontFamilyNunito}>
                      Operation Performed
                    </h6>
                    <input
                      className="form-control"
                      onChange={this.handleChange}
                      value={OperationPerformed}
                      name="OperationPerformed"
                      type="text"
                      required
                    />
                  </div>
                  <div className="py-1">
                    <h6 className="text-capitalize" style={fontFamilyNunito}>
                      Immediate recovery care
                    </h6>
                    <input
                      className="form-control"
                      onChange={this.handleChange}
                      value={Immediaterecoverycare}
                      name="Immediaterecoverycare"
                      type="text"
                      required
                    />
                  </div>
                </div>
             

                <div className="col-md-4 p-2">
                  <div className="py-1">
                    <h6 className="text-capitalize" style={fontFamilyNunito}>
                      Hand overgiven
                    </h6>
                    <input
                      className="form-control"
                      onChange={this.handleChange}
                      value={Handovergiven}
                      name="Handovergiven"
                      type="text"
                      required
                    />
                  </div>
                  <div className="py-1">
                    <h6 className="text-capitalize" style={fontFamilyNunito}>
                      Date And Time of Analysis
                    </h6>
                    <input
                      className="form-control"
                      onChange={this.handleChange}
                      value={Datetime}
                      name="Datetime"
                      type="datetime-local"/>
                    
                  </div>
                </div>
               
              </div>
              <div
                className="alert alert-danger"
                id="SubmitError"
                style={displayHidden}
                role="alert"
              >
                <strong> </strong>Something went wrong. Please try again
              </div>
              <div
                id="loginSuccess"
                className="alert alert-success"
                style={displayHidden}
                role="alert"
              >
                <strong>Success! </strong>Details Saved Successfully.
              </div>

              <div className="row">
                <br />
                <br />
                <br />
                {/* <div style={displayHidden} className="col col-6"><button className="btn btn-primary btn-warning rounded-pill px-4 font-weight-bold" type="button" style={floatRight}>Send To Triage</button></div> */}
                <div className="col col-6">
                  <button
                    className="btn btn-primary btn-warning rounded-pill px-5 font-weight-bold"
                    type="submit"
                    style={floatLeft}
                  >
                    {loading ? 'Loading' : 'Submit'}
                  </button>
                </div>
              </div>
            </form>
          </div>
        </main>
      </div>
    );
  }
}

export default PostOpPreliminary;
